import { Mail } from 'lucide-react';
import Table from '@/components/table/components/Table.tsx';
import EmptyTable from '@/components/table/components/EmptyTable.tsx';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import messagesApi from '@/features/dashboard/messages/api/messagesApi.ts';
import { messagesApiQueryKeys } from '@/features/dashboard/messages/api/messagesApi.queryKeys.ts';
import useMessageRowActions from '@/features/dashboard/messages/hooks/useMessageRowActions.ts';
import useGetBookingDetails from '@/features/dashboard/bookings/hooks/useGetBookingDetails.ts';
import { useDetailsScreen } from '@/features/dashboard/bookingChanges/contexts/DetailsContext.ts';
import { bookingDetailsMessagesRoute } from '@/features/dashboard/bookingChanges/routes/bookingDetailsRoute.ts';

/**
 * Zakładka „Wiadomości” ekranu rezerwacji — co poszło w sprawie tej rezerwacji.
 *
 * Backend liczy tu wiadomości ostemplowane rezerwacją, wysłane do jej
 * uczestników oraz wysłane do zapisującego bez stempla rezerwacji.
 */
const BookingMessagesTab = () => {
  const { bookingId } = useDetailsScreen();
  const search = bookingDetailsMessagesRoute.useSearch();
  // Metryczkę rezerwacji dociąga loader ekranu, więc wyjazd jest tu od pierwszego rysowania.
  const { data: booking } = useGetBookingDetails(bookingId);
  const rowContextMenuItems = useMessageRowActions(booking?.tourId);

  return (
    <Table
      listSearch={search}
      queryKey={messagesApiQueryKeys.byBooking(bookingId)}
      fetchData={(pr, fc: FilterCriteriaDto) =>
        messagesApi.getScopedMessages({ booking: bookingId }, pr, fc)
      }
      fetchTableDef={() =>
        messagesApi.getScopedTableDefinition({ booking: bookingId })
      }
      rowContextMenuItems={rowContextMenuItems}
      emptyDataComponent={
        <EmptyTable
          title="Brak wiadomości"
          description="Tutaj pojawią się wiadomości wysłane w sprawie tej rezerwacji."
          icon={<Mail />}
        />
      }
    />
  );
};

export default BookingMessagesTab;
